import React from 'react';
import SocialMediaHero from '../components/SocialMediaHero';
import SocialMediaIntroSection from '../components/SocialMediaIntroSection';
import TrustedSocialMediaAgencySection from '../components/TrustedSocialMediaAgencySection';
import TopSocialMediaChannelsSection from '../components/TopSocialMediaChannelsSection';
import SmmGrowthRoleSection from '../components/SmmGrowthRoleSection';
import SocialMediaTabsSection from '../components/SocialMediaTabsSection';
import SocialMediaDifferentiatorsSection from '../components/SocialMediaDifferentiatorsSection';
import FullServiceSmmAgencySection from '../components/FullServiceSmmAgencySection';
import SocialMediaCtaSection from '../components/SocialMediaCtaSection';
import SocialMediaPortfolioSection from '../components/SocialMediaPortfolioSection';
import SocialMediaAuditReportSection from '../components/SocialMediaAuditReportSection';
import DigitalMarketingTestimonialsSlider from '../components/DigitalMarketingTestimonialsSlider';
import ContactUs from '../components/ContactUs';

function SocialMediaMarketingPage() {
  return (
    <>
      <SocialMediaHero />
      <SocialMediaIntroSection />
      <TrustedSocialMediaAgencySection />
      <TopSocialMediaChannelsSection />
      <SmmGrowthRoleSection />
      <SocialMediaTabsSection />
      <SocialMediaDifferentiatorsSection />
      <FullServiceSmmAgencySection />
      <SocialMediaCtaSection />
      <SocialMediaPortfolioSection />
      <SocialMediaAuditReportSection />
      <DigitalMarketingTestimonialsSlider />
      <ContactUs />
    </>
  );
}

export default SocialMediaMarketingPage;
